<!-- Chatbot: host conteneur dans lequel le web component <mini-chatbot> sera injecté -->
<div #host class="tmn-chatbot-host"></div>
